module.exports = __webpack_public_path__ + "static/dab-c1aa27e2b75203df380448a515cadcf6.png";